import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined'
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined'
import { createFileRoute, Outlet, useLocation, useNavigate } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { useMe } from '@/shared/api/auth'
import { hasRole, PERMISSION_SUB_MODULES, ROLE_CODE_LIST } from '@/shared/const'
import { PageWrapper } from '@/shared/ui/page-wrapper'
import { PermissionGuard } from '@/shared/ui/permission-guard'
import { CustomTab } from '@/shared/ui/tab'
import { CustomTabs } from '@/shared/ui/tabs'

type RouteName = 'list' | 'roles'

const getTabFromPath = (pathname: string): RouteName => {
  return pathname.includes('/users/apk/roles') ? 'roles' : 'list'
}

export const Route = createFileRoute('/_auth/users/apk')({
  staticData: {
    meta: {
      title: 'Пользователи АПК',
      description: '',
    },
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const { data: meData } = useMe()

  const isOnayAdmin = hasRole(meData?.roles, ROLE_CODE_LIST.ADMIN_ONAY_BILIM)

  const tab = getTabFromPath(location.pathname)

  const handleTabChange = (value: RouteName) => {
    navigate({ to: `/users/apk/${value}` })
  }

  return (
    <PermissionGuard permission={PERMISSION_SUB_MODULES.USERS_APK}>
      <PageWrapper title={t('Пользователи АПК')}>
        <CustomTabs value={tab} onChange={(_, value) => handleTabChange(value)}>
          <CustomTab
            value="list"
            icon={<PeopleAltOutlinedIcon />}
            iconPosition="start"
            label={t('Пользователи')}
          />
          <CustomTab
            disabled={!isOnayAdmin}
            value="roles"
            icon={<WorkOutlineOutlinedIcon />}
            iconPosition="start"
            label={t('Роли')}
          />
        </CustomTabs>
        <Outlet />
      </PageWrapper>
    </PermissionGuard>
  )
}
